export default __webpack_public_path__ + "static/media/rocket.949e9b29.webp";